import { createFileRoute } from "@tanstack/react-router";

import { RequireAuth } from "../../features/auth/RequireAuth";
import { AdminLandingPage } from "../../features/admin/AdminLandingPage";

export const Route = createFileRoute("/admin/")({
  component: () => (
    <RequireAuth>
      {(user) => (
        <AdminLandingPage
          uid={user.uid}
          email={user.email}
          signOut={user.signOut}
        />
      )}
    </RequireAuth>
  ),
});
